import React from 'react';
import { useQuest } from '../hooks/useQuest';

const TestQuestPage: React.FC = () => {
  const financialGuruQuest = useQuest('financial-guru');

  const testCompleteQuest = () => {
    console.log('Testing complete quest...');
    financialGuruQuest.completeQuest();
  };

  const testStartQuest = () => {
    console.log('Testing start quest...');
    financialGuruQuest.startQuest();
  };

  const testResetQuest = () => {
    console.log('Testing reset quest...');
    financialGuruQuest.resetQuest();
  };

  const clearLocalStorage = () => {
    console.log('Clearing localStorage...');
    localStorage.removeItem('quest_financial-guru');
    window.location.reload();
  };

  const setCompletedState = () => {
    console.log('Setting completed state...');
    const completedState = {
      isStarted: false,
      timeRemaining: 0
    };
    localStorage.setItem('quest_financial-guru', JSON.stringify(completedState));
    window.location.reload();
  };

  const setStartedState = () => {
    console.log('Setting started state...');
    const startedState = {
      isStarted: true,
      timeRemaining: 86400 // 24 hours
    };
    localStorage.setItem('quest_financial-guru', JSON.stringify(startedState));
    window.location.reload();
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Quest State Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Current State:</h3>
        <p>isStarted: {financialGuruQuest.isStarted.toString()}</p>
        <p>timeRemaining: {financialGuruQuest.timeRemaining}</p>
        <p>progressPercentage: {financialGuruQuest.progressPercentage}%</p>
        <p>Completed: {(financialGuruQuest.progressPercentage >= 100).toString()}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Actions:</h3>
        <button onClick={testStartQuest} style={{ marginRight: '10px', padding: '10px' }}>
          Start Quest
        </button>
        <button onClick={testCompleteQuest} style={{ marginRight: '10px', padding: '10px' }}>
          Complete Quest
        </button>
        <button onClick={testResetQuest} style={{ marginRight: '10px', padding: '10px' }}>
          Reset Quest
        </button>
        <button onClick={clearLocalStorage} style={{ padding: '10px' }}>
          Clear localStorage
        </button>
        <button onClick={setCompletedState} style={{ marginLeft: '10px', padding: '10px' }}>
          Set Completed State
        </button>
        <button onClick={setStartedState} style={{ marginLeft: '10px', padding: '10px' }}>
          Set Started State
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>localStorage:</h3>
        <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '5px' }}>
          {localStorage.getItem('quest_financial-guru') || 'No data'}
        </pre>
      </div>

      <div>
        <a href="/quests" style={{ color: 'blue', textDecoration: 'underline' }}>
          Go to Quests Page
        </a>
      </div>
    </div>
  );
};

export default TestQuestPage; 